<template>
  <!-- 分成管理 -->
  <div class="">
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" label-width="90px" ref="formData">
        <el-form-item label="一级货主:">
          <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:">
          <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[2]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[3]">重置</el-button>
          <el-button type="primary" size="mini" @click="tianjia" v-if="btnFlg[4]">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"
        style="width: 100%" class="elTab">
        <el-table-column type="index" width="60" label="序号"></el-table-column>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button type="text" v-if="btnFlg[5]" @click="detail(scope.row)" size="mini">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center"
          :formatter="dateFormat">
        </el-table-column>

      </el-table>
    </div>

    <div class="pags">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
      </el-pagination>
    </div>
    <el-dialog class="oneTwo" :visible.sync="dialogVisible" title="结算货主" append-to-body width="30%" center
      :close-on-click-modal="false">
      <div style="">
        <el-form  :rules="rules" :model="addForm" label-width="120px" ref="addForm">
          <el-form-item label="一级货主:" prop="primaryCustomerTaxId" :rules="[
                  {
                    required: true,
                    message: '请选择一级货主',
                    trigger: 'change',
                  },
                ]">
            <el-select v-model="addForm.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:" prop="customerTaxId"
            :rules="[{required:true,message:'请选择二级货主',trigger:'change'}]">
            <el-select v-model="addForm.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <div style="width:150px;margin:15px auto;">
          <el-button type="primary" size="mini" @click="dialogVisible=false">取消</el-button>
          <el-button type="primary" size="mini" @click="baocun()">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getBtn
} from '@/utils/getButton'
import columns from './receiveDtableColumn'
import {
  exportExcel
} from '@/utils/fileDown.js'
import DonMessage from '@/utils/message'

import {
  getSettlementOwnerList,
  addSettlementOwner,
  DelSettlementOwnerList,
  getRelationCustomer
} from '@/api/wms-stock'
export default {
  name: 'settlementSettings',
  components: {},
  mixins: [columns],
  data () {
    return {
      rules: {
        primaryCustomerTaxId: [{
          required: true,
          message: '请选择一级货主',
          trigger: 'change'
        }],
        customerTaxId: [{
          required: true,
          message: '请选择二级货主',
          trigger: 'change'
        }]

      },
      dialogVisible: false,
      addForm: {
        customerTaxId: '',
        primaryCustomerName: '',
        customerName: '',
        primaryCustomerTaxId: ''
      },
      formData: {
        customerTaxId: '',
        primaryCustomerTaxId: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      RKData: [],
      btnFlg: [],
      btnIdArr: [
        '003M3X0100',
        '003M3X0200',
        '003M3X0300',
        '003M3X0400',
        '003M3X0500',
        '003M3X0600',
        '003M3X0700'
      ],
      h: '500px',
      tableData: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/settlementSettings')
    console.log(this.btnFlg, ' this.btnFlg')
  },
  mounted () {
    this.chaxun()
    this.getRelationCustomer()
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 220 + 'px'
  },
  methods: {
    // 删除
    detail (row) {
      this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          DelSettlementOwnerList({
            settlementOwnerId: row.settlementOwnerId
          }).then(res => {
            DonMessage.success('操作成功')
            loading.close()
            this.chaxun()
          })
            .catch((err) => {
              loading.close()

              DonMessage.error(err.message)
            })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    tianjia () {
      this.dialogVisible = true
      this.addForm = {}
      if (this.addForm) {
        this.$refs.addForm.resetFields()
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    baocun () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let a = this.RKData.filter((x) => x.taxpayerNumber == this.addForm.primaryCustomerTaxId)[0]
          let b = this.RKData.filter((x) => x.taxpayerNumber == this.addForm.customerTaxId)[0]
          this.addForm.primaryCustomerName = a.custerName
          this.addForm.customerName = b.custerName
          addSettlementOwner({
            ...this.addForm
          })
            .then(res => {
              this.dialogVisible = false
              DonMessage.success('操作成功')

              loading.close()
              this.chaxun()
            })
            .catch(err => {
              loading.close()

              this.$message({
                message: err.message,
                type: 'error'
              })
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getRelationCustomer () {
      getRelationCustomer()
        .then(res => {
          console.log(res)
          this.RKData = res
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    chaxun () {
      getSettlementOwnerList({
        ...this.formData,
        ...this.pageInfo
      })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    chongzhi () {
      this.formData = {}
      this.chaxun()
    },
    // 导出
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/inventory/exportDivideFeeList',
        this.formData,
        '分成查询表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    }
  }
}

</script>
<style lang='less' scoped>
  // /deep/.el-form-item {
  //   margin-bottom: 15px;
  // }
  /deep/.el-tabs__header {
    margin: 0;
  }
</style>
